import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetComponent } from './reset/reset.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SummaryComponent } from './summary/summary.component';
import { ChangeDigitalSignatureService } from './change-digital-signature.service';
import { ChangeDigitalSignatureComponent } from './change-digital-signature.component';
import { SecurityCheckComponent } from './security-check-signature/security-check-signature.component';
import { SmsValidationComponent } from './sms-validation-signature/sms-validation-signature.component';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule } from 'ngx-mask';
import { ResetWithStepsComponent } from './reset-with-steps/reset-with-steps.component';
import { MatCardModule } from '@angular/material';


@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		TextMaskModule,
		NgxMaskModule.forRoot(),
		MatCardModule
	],
	declarations: [
		ChangeDigitalSignatureComponent,
		ResetComponent,
		SummaryComponent,
		SecurityCheckComponent,
		SmsValidationComponent,
		ResetWithStepsComponent
	],
	providers: [ChangeDigitalSignatureService]
})
export class ChangeDigitalSignatureModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-digital-signature/change-digital-signature.module.ts